import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { config } from '../config';
import axios from 'axios';
import { validateEmail } from '../utils/validation';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [emailTouched, setEmailTouched] = useState(false);
  const [status, setStatus] = useState(null); // null | 'sending' | 'sent'
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailTouched(true);
    if (validateEmail(email)) return;

    setStatus('sending');
    setError('');
    try {
      await axios.post(`${config.getBackendUrl()}/forgot_password`, { email });
      setStatus('sent');
    } catch {
      setStatus(null);
      setError('Something went wrong. Please try again.');
    }
  };

  if (status === 'sent') {
    return (
      <div className="center-container">
        <div className="card">
          <h1>Check your email</h1>
          <p style={{ color: '#666', marginTop: '12px' }}>
            If an account exists for <strong>{email}</strong>, you'll receive a password reset link shortly.
          </p>
          <p style={{ marginTop: '24px' }}>
            <Link to="/">Back to login</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-container">
      <div className="card">
        <h1>Forgot password</h1>
        <p style={{ color: '#666', marginBottom: '24px' }}>
          Enter your email and we'll send you a reset link.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="field-wrapper">
            <label className="field-label" htmlFor="email">Email</label>
            <input
              id="email"
              className={`input${emailTouched && validateEmail(email) ? ' input-invalid' : emailTouched && !validateEmail(email) ? ' input-valid' : ''}`}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={() => setEmailTouched(true)}
            />
            {emailTouched && validateEmail(email) && (
              <p className="field-error">{validateEmail(email)}</p>
            )}
          </div>
          {error && <p className="field-error">{error}</p>}
          <button type="submit" className="button" style={{ width: '100%' }} disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending...' : 'Send reset link'}
          </button>
        </form>
        <p style={{ marginTop: '16px' }}>
          <Link to="/">Back to login</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
